import { Grid } from '@mui/material';
import { usePageTitle } from '@hooks/usePageTitle';
import { Header } from '@layouts/Base/components/Header';
import { buildRoutePath } from '@navigation/buildRoutePath';
import { Routes } from '@navigation/routes';
import indents from '@styles/indents.module.scss';
import { NewTicketData } from '@area/tickets/components/NewTicketData';

export const NewTicket = () => {
  usePageTitle('Новое обращение');

  return (
    <Grid container flexDirection="column" gap={indents.m}>
      <Grid item container flexDirection="column" gap={indents.xxs}>
        <Header
          title="Новое обращение"
          backBtnTitle="Назад к списку обращений"
          backBtnRoute={buildRoutePath([Routes.tickets], {
            absolute: true,
          })}
        />
      </Grid>
      <Grid item>
        <NewTicketData />
      </Grid>
    </Grid>
  );
};
